import { CameraContainer } from "./camera-container.component";
import { CameraError } from "./error";
import { CameraLoad } from "./load";
import { CameraConfigButton, CameraPhotoButton, CameraRecordButton } from "./stream";
export const components = {
  CameraContainer,
  CameraLoad,
  CameraError,
  CameraConfigButton,
  CameraPhotoButton,
  CameraRecordButton
};